import withIcon from './NewIcon';
// @ts-ignore
import IconLogo from './icon/other/logo.s.svg';

export default withIcon(IconLogo);
